export default __webpack_public_path__ + "static/banner-why-a-personal-loan-is-the-best-way-to-buy-your-dream-car-18193d0e7bf2387f597e041e9b3364d3.jpg";